import * as React from "react";

export const fields = (type, keyName) => {
    return {
        config: {columns: 1},
        fields: [
            {
                name: "value",
                label: keyName,
                column: 1,
                type: type
            },
            {
                name: "key",
                type: "unvisible",
                column: 1,
            }
        ]
    }
};
